// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ2_NEW_MESSAGE = "Nov\u00e1 spr\u00e1va";
